var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBatteryIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 21.523,
    viewBox: "0 0 51.891 21.523",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5886",
    "data-name": "Group 5886",
    transform: "translate(-1436 -266.477)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5885",
    "data-name": "Group 5885",
    transform: "translate(1436 266.477)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3539",
    "data-name": "Path 3539",
    d: "M8.512,222.381q9.481,0,18.962,0A5.561,5.561,0,0,1,33.094,227a1.69,1.69,0,0,0,1.047,1.482,2.734,2.734,0,0,1,1.531,2.562c.024,1.382.02,2.765,0,4.147a3.04,3.04,0,0,1-2.03,2.867.6.6,0,0,0-.461.623,5.583,5.583,0,0,1-4.59,5.113,6.223,6.223,0,0,1-1.16.1q-18.922.008-37.844,0a5.62,5.62,0,0,1-5.784-5.768q-.016-4.992,0-9.984a5.62,5.62,0,0,1,5.784-5.767Q-.949,222.377,8.512,222.381Zm.023,2.08H2.617q-6.522,0-13.045,0a3.538,3.538,0,0,0-3.687,3.551c-.013,3.422-.02,6.845.014,10.267a3.715,3.715,0,0,0,.383,1.579,3.49,3.49,0,0,0,3.382,1.964q18.843-.006,37.686,0a3.567,3.567,0,0,0,3.789-3.583,2.056,2.056,0,0,1,1.606-2.054,1.087,1.087,0,0,0,.858-1.158q.007-1.892,0-3.785a1.081,1.081,0,0,0-.831-1.137,2.064,2.064,0,0,1-1.633-2.074,3.566,3.566,0,0,0-3.8-3.571Z",
    transform: "translate(16.202 -222.38)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3540",
    "data-name": "Path 3540",
    d: "M44.4,280.69H25.6a2.155,2.155,0,0,1-2.376-2.365q0-4.892,0-9.784a2.142,2.142,0,0,1,2.315-2.3q18.842,0,37.685,0a2.25,2.25,0,0,1,1.936.868,2.1,2.1,0,0,1,.414,1.317c0,3.355,0,6.71,0,10.066a2.108,2.108,0,0,1-2.246,2.2Q53.864,280.692,44.4,280.69Z",
    transform: "translate(-20.049 -262.701)",
    fill: "#0f8"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_82_",
    "data-name": "82%",
    transform: "translate(1460.742 281.712)",
    fill: "#3b3b3b",
    fontSize: 13,
    fontFamily: "OpenSans-Bold, Open Sans",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -13.276,
    y: 0
  }, "82%")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryIcon);
export default __webpack_public_path__ + "static/media/BatteryIcon.c758c4c27933e3eaed068e256e88b81a.svg";
export { ForwardRef as ReactComponent };